import * as yup from "yup";

import { AccountantService, LocalStorageService } from "../../services";
import {
	EmailFieldRHF,
	EnhancedSnackbar,
	RHookFormPasswordFieldWithLabel,
	RHookFormTextFieldWithLabel,
	Spacer,
	StyledRouterLink,
	SubmitButton,
	SubmitButtonVariant,
} from "@websential/cosmic-v20";
import { FormProvider, useForm } from "react-hook-form";
import { ISignInRequest, ISignInResponse } from "../../models";
import {
	setSelectedAccountant,
	setSelectedAccountantName,
	setSelectedClient,
	signInSuccess,
} from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";

import { AccountFormLayout } from "../AccountFormLayout";
import { AuthService } from "../../services/AuthService";
import Grid from "@mui/material/Grid";
import { IGetListRequest } from "../../models/common";
import { INITIAL_SNACKBAR_DATA } from "../../common/constants";
import { Typography } from "@mui/material";
import { useNavigateToLogout } from "../../common/Common";
import { yupResolver } from "@hookform/resolvers/yup";

const BackupCodeVerificationComponent = () => {
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [authData, setAuthData] = useState({});
	const navigateToLogout = useNavigateToLogout();
	const [accountantQueryParams, setaccountantQueryParams] =
		useState<IGetListRequest>({
			search_query: "",
			order_by: "acc_title",
			order_direction: "asc",
			page: 1,
			size: 25,
		});
	const [clientQueryParams, setclientQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "client_name",
		order_direction: "asc",
		page: 1,
		size: 25,
	});
	// const loading = useSelector((state: any) => state.viewState.loading);
	const dispatch = useDispatch();
	const methods = useForm<ISignInRequest>({
		// resolver: yupResolver(loginFormSchema),
	});

	/**
	 * On Snackbar closed.
	 *
	 * @param {React.SyntheticEvent | Event} event
	 * @param {string} reason
	 */
	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isSubmitting, mutate: submitFormFields } = useMutation({
		mutationFn: AuthService.signIn,
		onSuccess: (res: ISignInResponse) => {
			if (res.status) {
				LocalStorageService.setUser(res);
				setSnackbarData({
					open: true,
					message: res.message,
					severity: "success",
				});
				dispatch(signInSuccess(res));
				if (res.user.isSuperStatus !== 400) {
					(async () => {
						try {
							const accountantResponse: any =
								await AccountantService.getAccountants(accountantQueryParams, res.user.isSuperStatus);
							if (accountantResponse && accountantResponse.items.length === 1) {
								dispatch(setSelectedAccountant(accountantResponse.items[0]));
								dispatch(setSelectedAccountantName(accountantResponse.items[0]));
								try {
									const clientResponse: any =
										await AccountantService.getClientByAccountantId(
											accountantResponse.items[0].id,
											res.user.isSuperStatus,
											clientQueryParams,
											navigateToLogout
										);
									if (clientResponse && clientResponse.items.length === 1) {
										dispatch(setSelectedClient(clientResponse.items[0]));
									}
								} catch { }
							} else if (
								accountantResponse &&
								accountantResponse.items.length === 0
							) {
								try {
									const clientResponse: any =
										await AccountantService.getClientByAccountantId(
											"",
											res.user.isSuperStatus,
											clientQueryParams,
											navigateToLogout
										);
									if (clientResponse && clientResponse.items.length === 1) {
										dispatch(setSelectedClient(clientResponse.items[0]));
									}
								} catch { }
							}
						} catch { }
					})();
				}
			} else {
				setSnackbarData({
					open: true,
					message: res.message,
					severity: "error",
				});
			}
		},
		onError: (err: any) => {
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const onSubmit = (loginRequest: ISignInRequest) => {
		submitFormFields(loginRequest);
		setAuthData(loginRequest);
	};

	return (
		<>
			<FormProvider {...methods}>
				<form onSubmit={methods.handleSubmit(onSubmit)}>
					<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
						<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
							Enter one of your 8-digit backup code
						</Grid>
						<Spacer y={1} x={2} />
						<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
							<RHookFormPasswordFieldWithLabel
								label="Backup Code"
								id="backup code"
								testId="backup-code"
								placeholder="Enter the backup code"
							/>
						</Grid>
					</Grid>
					<SubmitButton
						label="Validate"
						variant={SubmitButtonVariant.Primary}
						testId="sign-in-button"
						loading={isSubmitting}
					/>
				</form>
			</FormProvider>
			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId="login-form-snackbar"
				open={snackbarData.open}
				autoHide={true}
			/>
		</>
	);
};

export const BackupCodeVerificationForm = () => {
	return (
		<AccountFormLayout
			title="Welcome to SimplePay"
			subtitle="Having trouble with this method?"
			subtitleLinkText="Select another method."
			subtitleLinkNavigateTo="/auth-selection-screen"
			form={<BackupCodeVerificationComponent />}
		/>
	);
};
